import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class OrderReferencePattern {

  @JsonProperty()
  idText: string | undefined;

  @JsonProperty()
  originOwner: string | undefined;

  @JsonProperty()
  originClearingHouseCode: string | undefined;

  @JsonProperty()
  owner: string | undefined;

  @JsonProperty()
  clearingHouseCode: string | undefined;

  @JsonProperty()
  pattern: string | undefined;

  @JsonProperty()
  validationRegex: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
